import { render, staticRenderFns } from "./PublicRemovalView.vue?vue&type=template&id=2e849fd9&scoped=true&"
import script from "./PublicRemovalView.vue?vue&type=script&lang=js&"
export * from "./PublicRemovalView.vue?vue&type=script&lang=js&"
import style0 from "./PublicRemovalView.vue?vue&type=style&index=0&id=2e849fd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e849fd9",
  null
  
)

export default component.exports